<template>
  <div class="bg-white rounded">
    <spinner v-if="loading"></spinner>

    <div v-else>
      <log-filter class="mb-3" @filterChanged="filterChanged"/>

      <empty-list-view v-if="areLogsEmpty"
                       title="No logs found."
                       description="Check the filters. If you still don't see any logs, then send or receive message to one of your channels.">
      </empty-list-view>

      <div v-else>
        <!-- 'div' is used instead of 'table' so that 'multiCollapse' is working -->
        <div class="container-fluid mb-4">
          <div class="row py-1 border-top">
            <div class="col-1"><strong>Status</strong></div>
            <div class="col-3"><strong>Type</strong></div>
            <div class="col-3"><strong>Channel ID</strong></div>
            <div class="col-3"><strong>Timestamp</strong></div>
            <div class="col-2"></div>
          </div>
          <div v-for="(event, index) in events" :key="event.timestamp + index">
            <log-item :event="event" :index="index"></log-item>
          </div>
        </div>

        <b-pagination v-model="pagination.currentPage"
                      :total-rows="pagination.totalItems"
                      :per-page="pagination.listMaxSize"
                      :hide-goto-end-buttons="hideGoToEndButtons"
                      @change="page => pagination_pageChanged($route.query, getLogs)(page)">
        </b-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import LogItem from '@/components/administration/log/common/log-item/LogItem.vue'
  import logService from '@/services/amio-api/event.service'
  import channelService from '@/services/amio-api/channel.service'
  import EmptyListView from '@/components/administration/common/EmptyListView'
  import isEmpty from 'ramda/src/isEmpty'
  import merge from 'ramda/src/merge'
  import loadingMixin from '@/mixins/loading.mixin'
  import paginationMixin from '@/mixins/pagination.mixin'
  import 'vue-awesome/icons/trash'
  import 'vue-awesome/icons/arrow-left'
  import 'vue-awesome/icons/filter'
  import LogFilter from '@/components/administration/log/common/LogFilter'

  export default {
    mixins: [
      paginationMixin,
      loadingMixin
    ],

    components: {
      'empty-list-view': EmptyListView,
      'log-filter': LogFilter,
      'log-item': LogItem
    },

    data() {
      return {
        channelId: null,
        events: [],
        integrationForDeletion: {}
      }
    },

    computed: {
      areLogsEmpty() {
        return isEmpty(this.events)
      },
      hideGoToEndButtons() {
        return this.pagination_getTotalItems() < parseInt(process.env.VUE_APP_PAGINATION_ITEMS_SHOW_END_BUTTONS)
      }
    },

    methods: {
      getLogs() {
        this.loading = true
        const paginationParams = this.pagination_createParams()
        const params = merge({}, paginationParams)
        const routeQuery = this.$route.query

        if (routeQuery.type !== undefined) {
          params.type = routeQuery.type
        }

        if (routeQuery.status === ('error')) params.status = 'error'
        if (routeQuery.status === ('success')) params.status = 'ok'

        const fetchLogsPromise = this.channelId
          ? channelService.getLogs(this.channelId, params)
          : logService.list(params)

        fetchLogsPromise.then(({items, totalItems}) => {
          this.events = items
          this.pagination_setTotalItems(totalItems)
          this.loading = false
        })
      },

      filterChanged() {
        this.pagination_setCurrentPage(1)
        return this.getLogs()
      }
    },

    mounted() {
      this.channelId = this.$route.params.id
      this.getLogs()
    },

    beforeRouteUpdate(to, from, next) {
      if (to.query.page === this.pagination_getCurrentPage()) return next()

      this.pagination_setCurrentPage(to.query.page || 1)
      next(this.getLogs)
    }
  }
</script>
